import React from "react";
import { Flex } from "@chakra-ui/react";

import { PRODUCTION_STEPS_2S, PRODUCTION_STEPS_PS } from "@constants";
import { NewItemList } from "./NewItemList";
import { NewItemCardContent } from "./newModuleTypes";

const MODULE_ENTRY_POINT: NewItemCardContent[] = [
  {
    name: "2S Sensor",
    moduleTag: "2S",
    step: PRODUCTION_STEPS_2S.STEP_2S_SENSOR_VISUAL_INSPECTION,
  },
  {
    name: "PS-s Sensor",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_SENSOR_VISUAL_INSPECTION,
  },
  {
    name: "CF Baseplate",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_CF_BASEPLATE_INSERT_GLUING,
  },
  {
    name: "MaPSA",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_MA_PSA_VISUAL_INSPECTION,
  },
  {
    name: "PS VTRX",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_VTRX_VISUAL_INSPECTION,
  },
  {
    name: "2S VTRX",
    moduleTag: "2S",
    step: PRODUCTION_STEPS_2S.STEP_2S_VTRX_VISUAL_INSPECTION,
  },
];

const HYBRIDS_ENTRY_POINT: NewItemCardContent[] = [
  {
    name: "2S SEH",
    moduleTag: "2S",
    step: PRODUCTION_STEPS_2S.STEP_2S_SEH_VISUAL_INSPECTION,
  },
  {
    name: "2S Left FEH",
    moduleTag: "2S",
    step: PRODUCTION_STEPS_2S.STEP_2S_FEH_L_VISUAL_INSPECTION,
  },
  {
    name: "2S Right FEH",
    moduleTag: "2S",
    step: PRODUCTION_STEPS_2S.STEP_2S_FEH_R_VISUAL_INSPECTION,
  },
  {
    name: "PS FEH",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_FEH_VISUAL_INSPECTION,
  },
  {
    name: "PS ROH",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_ROH_VISUAL_INSPECTION,
  },
  {
    name: "PS POH",
    moduleTag: "PS",
    step: PRODUCTION_STEPS_PS.STEP_PS_POH_VISUAL_INSPECTION,
  },
];

/**
 * Component to display content for the New Module page.
 */
export function NewModuleDisplay() {
  return (
    <Flex margin="8px" flexDirection="column" gap="8px">
      <NewItemList title="sensor" startPoints={MODULE_ENTRY_POINT} />
      <NewItemList title="hybrid" startPoints={HYBRIDS_ENTRY_POINT} />
    </Flex>
  );
}
